/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://vvp3tb4fbnfqfjl4w3ybtcnjdq.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-lh453dbodvhknafjbm2yrap3ma",
    "aws_cognito_identity_pool_id": "eu-west-2:8c166231-a8f3-451c-8a59-3db5e6f4b38a",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_Q5lkMRz6x",
    "aws_user_pools_web_client_id": "5htt3r28352gat6f416c4irfju",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "canaillechic8a3c397b2686417480cb2e51ab0cda38224209-dev",
    "aws_user_files_s3_bucket_region": "eu-west-2",
    "aws_cognito_login_mechanisms": []
};


export default awsmobile;
